<script setup lang="ts">
const { getMerchantAttributes } = useLuxuryDesign();
const titleAttributes = computed(() => getMerchantAttributes(props.merchantId));

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  categoryId: {
    type: String,
    required: true,
  },
  merchantId: {
    type: String,
    required: true,
  },
  translationId: {
    type: String,
    required: true,
  },
  oneTime: {
    type: Boolean,
    default: false,
  },
  offerText: {
    type: String,
    default: "",
  },
  number: {
    type: Number,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
});
</script>
<template>
  <div
    v-bind="titleAttributes"
    class="px-7 py-5 overflow-hidden card-detail-title">
    <h1 class="text-lg text-neutral-300 card-detail-title__merchant">
      {{ $t(`main.merchant.${merchantId}`) }}
    </h1>
    <div class="flex items-center gap-x-4 gap-y-2 flex-wrap">
      <p
        class="text-neutral-200 text-2.5xl font-bold text-wrap merchant-heading"
        :class="{ 'merchant-heading--highlight': id === 'default-jewel' }">
        {{ $t(`${translationId}.title`) }}
        {{ $t(`${translationId}.subtitle`) }}
      </p>
      <h1
        v-if="oneTime"
        class="h-5 rounded-full text-neutral-500 text-xs font-bold flex items-center px-4"
        :class="`${getItemSpecialColor(id, 'bg')}`">
        {{ offerText }}
      </h1>
      <h1
        v-else-if="id === 'shop_item_0060'"
        class="h-5 rounded-full text-neutral-500 text-xs font-bold flex items-center px-4"
        :class="`${getItemSpecialColor(id, 'bg')}`">
        {{ offerText }}
      </h1>
    </div>
    <p
      v-if="categoryId"
      class="mt-4 max-w-fit h-6 py-1 px-6 text-center text-neutral-300 rounded-xs text-xs bg-secondary-500 order-first card-detail-title__category">
      {{ $t(`${merchantId}.property.categoryId.values.${categoryId}`) }}
    </p>
  </div>
</template>
